import { FBF_CloudCallable } from '@rabbit/firebase/adapter';
import {
  SendInviteUserEmailDto,
  SendResetPasswordEmailDto,
  SendClaimWaitingReviewEmailDto,
  SendNotifyRepairerEmailDto,
  SendChatMessageEmailDto,
} from '@rabbit/nest/api';

// Email API wrapper functions
export const nestApiSendInviteUserEmail = FBF_CloudCallable<SendInviteUserEmailDto, any>('api/emails/send-invite-user|POST');
export const nestApiSendResetPasswordEmail = FBF_CloudCallable<SendResetPasswordEmailDto, any>('api/emails/send-reset-password|POST');
export const nestApiSendClaimWaitingReviewEmail = FBF_CloudCallable<SendClaimWaitingReviewEmailDto, any>('api/emails/send-claim-waiting-review|POST');
export const nestApiSendNotifyRepairerEmail = FBF_CloudCallable<SendNotifyRepairerEmailDto, any>('api/emails/send-notify-repairer|POST');
export const nestApiSendChatMessageEmail = FBF_CloudCallable<SendChatMessageEmailDto, any>('api/emails/send-chat-message|POST');
